import { Injectable } from '@angular/core';
import { DatabaseService } from './base/database.service';
import { Pii } from '../models/pii.model';
import { UserService, UpdateProfileRequest, UpdateProfileResponse } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class PiiService extends DatabaseService<Pii> {
  constructor(private userService: UserService) {
    super('cp_pii');
  }

  /**
   * Método centralizado que delega para UserService.updateProfile()
   * Garante validações de KYC, permissões e sync com AWS Connect
   */
  async updateProfile(request: UpdateProfileRequest): Promise<UpdateProfileResponse> {
    return this.userService.updateProfile(request);
  }

  /**
   * @override DatabaseService.update()
   * Delega para updateProfile() com validações automáticas
   */
  override async update(t: Partial<Pii>) {
    const response = await this.updateProfile({ pii: t });

    if (!response.success || !response.pii) {
      throw new Error(response.errors?.join(', ') || 'Erro ao atualizar PII');
    }

    // Retorna array para manter compatibilidade com código existente (DatabaseService)
    return [response.pii];
  }

  /**
   * @override DatabaseService.create()
   * Delega para updateProfile() - CREATE vira UPSERT automático no backend
   * O /profile endpoint trata automaticamente criação de PII quando necessário
   */
  override async create(t: Partial<Pii>) {
    const response = await this.updateProfile({ pii: t });

    if (!response.success || !response.pii) {
      throw new Error(response.errors?.join(', ') || 'Erro ao criar PII');
    }

    // Retorna array para manter compatibilidade com código existente (DatabaseService)
    return [response.pii];
  }

  async getFromUserId(uid: string): Promise<Pii> {
    const ret = await this.supabase
      .from('cp_pii')
      .select('*')
      .eq('user_id', uid)
      .single();

    return ret.data as unknown as Pii;
  }
}
